import { localStorage } from '@/utils/localStorage'

export default {
  methods: {
    // 读取localStorage的filter options
    loadOptions(key, callback) {
      return new Promise((resolve, reject) => {
        try {
          // 查询localStorage是否存在option
          const options = localStorage.get('userOptions')
          if (this.$_.has(options, key)) {
            // 判断当前的accountId是否有options
            const loginAsAccountId = localStorage.get('loginAsAccountId')
            const accountId = localStorage.get('accountId')
            const cur_filterOption = options[key].find(item => item.id === (loginAsAccountId || accountId))
            
            if (cur_filterOption && typeof callback === 'function') {
              Promise.resolve(callback(cur_filterOption)).then(resolve).catch(reject);
            } else {
              resolve();
            }
          } else {
            resolve();
          }
        } catch(error) {
          reject(error);
        }
      })
    },
  }
}